<template>
  <!-- Api 自动化管理 -->
  <div class="page">
    <div class="paginations">
      <!-- 一级搜索表单 -->
      <div class="table-search-box table-search-box-hander" v-show="oneShow">
        <el-form :inline="true" class="demo-form-inline" :model="searchData">
          <el-form-item label="任务模块：">
            <el-select size="small" v-model="searchData.id" placeholder="请选择任务模块" :popper-append-to-body="false" @change="changeTask" filterable="">
              <el-option v-for="(item,index) in drowDown.TaskModuleList" :key="index" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="search_button">
              <i class="pointer el-icon-search" @click="search"></i>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <!-- 二级搜索表单 -->
      <div class="table-search-box table-search-box-hander" v-show="oneShow == false">
        <el-form :inline="true" class="demo-form-inline" :model="searchDataTow">
          <el-form-item label="资源库名称：">
            <el-select v-model="searchDataTow.zykName" clearable filterable>
              <el-option v-for="item in drowDown.zykArrList" :key="item.zykid" :label="item.zykName" :value="item.zykName"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="学校名称：">
            <el-input type="text" v-model="searchDataTow.schoolName" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="任务状态">
            <el-select size="medium" v-model="searchDataTow.taskStatus" placeholder="请选择任务类型" :popper-append-to-body="false">
              <el-option v-for="(item,index) in drowDown.StatusList" :key="index" :label="item.status" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <div class="search_button">
              <i class="pointer el-icon-search" @click="searchTwoTable"></i>
            </div>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" class="back" @click="backOneTable">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- @click="chageTablist" -->

      <!-- 一级表格 -->
      <div class="table_box" v-show="oneShow">
        <el-table :data="tableData.OneTable">
          <el-table-column type="index" label="序号" align='center'></el-table-column>
          <el-table-column prop="taskName" label="任务名称" align='center'></el-table-column>
          <el-table-column prop="waiting" label="任务-等待中(个数)" align='center'></el-table-column>
          <el-table-column prop="runing" label="任务-执行中(个数)" align='center'></el-table-column>
          <el-table-column prop="success" label="任务-成功(个数)" align='center'></el-table-column>
          <el-table-column prop="error" label="任务-失败(个数)" align='center'></el-table-column>
          <el-table-column label="操作" align='center'>
            <template slot-scope="scoped">
              <i class="icona icon-details" title="查看年度报告" @click="see(scoped.row.taskType)"></i>
            </template>
          </el-table-column>
        </el-table>
        <!-- <pageNumber :paginations="7" :pageNum="pageDto.pageNum" :pageSize="pageDto.pageSize" :total="total" :jumpTo="pageDto.pageNum" @currentChange="changeHandler"></pageNumber> -->
      </div>

      <!-- 第二个表格 -->
      <div class="table_box" v-show="oneShow == false">
        <el-table :data="tableData.towTable.list">
          <el-table-column type="index" label="序号" align='center'></el-table-column>
          <el-table-column prop="taskId" label="任务名称" align='center'>
          </el-table-column>
          <el-table-column prop="zykName" label="资源库名称" align='center'></el-table-column>
          <el-table-column prop="schoolName" label="学校名称" align='center'></el-table-column>

          <el-table-column prop="taskStatus" label="任务状态" align='center'>
            <template v-slot="scoped">
              <span v-show="scoped.row.taskStatus=='等待中'">{{scoped.row.taskStatus}}</span>
              <span :class="[scoped.row.taskStatus=='成功'?'success':null]" v-show="scoped.row.taskStatus=='成功'">{{scoped.row.taskStatus}}</span>
              <span :class="[scoped.row.taskStatus=='失败'?'error':null]" v-show="scoped.row.taskStatus=='失败'">{{scoped.row.taskStatus}}</span>
              <span :class="[scoped.row.taskStatus=='执行中'?'implement':null]" v-show="scoped.row.taskStatus=='执行中'">{{scoped.row.taskStatus}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="lastUpdateTime" label="上次更新时间" align='center'></el-table-column>
          <el-table-column prop="createTime" label="开始执行时间" align='center'></el-table-column>
          <el-table-column prop="performTime" label="运行耗时（单位：分钟）" align='center'></el-table-column>

          <el-table-column prop="failInfo" label="失败信息" align='center' v-if="showErrorInfo">
            <template v-slot="scoped">
              <el-tooltip effect="dark" placement="top-start">
                <div slot="content" style="width: 340px;overflow-y: auto;height: 200px;font-size: 13px;">{{content}}</div>
                <span>{{scoped.row.failInfo}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <pageNumber :paginations="7" :pageNum="searchDataTow.pageDto.pageNum" :pageSize="searchDataTow.pageDto.pageSize" :total="tableData.towTable.total" :jumpTo="searchDataTow.pageDto.pageNum" @currentChange="changeHandler"></pageNumber>
      </div>
    </div>
  </div>
</template>

<script>

import pageNumber from '@/components/pageNumber.vue'; // 分页

export default {

  components: {
    pageNumber,
  },

  data() {
    return {
      searchData: {
        id: 1,
        taskModule: ''
      },

      // 一级表格
      oneShow: true,

      tableData: {
        // 一级表格
        OneTable: [],

        towTable: {
          list: [],
          total: null
        }
      },

      // 二级表格
      searchDataTow: {
        pageDto: {
          pageNum: 1,
          pageSize: 10
        },
        schoolName: '',
        taskStatus: 0,
        taskType: null,
        zykName: ''
      },


      // 下拉框的数据存放
      drowDown: {
        StatusList: [{ id: 0, status: '全部' }, { id: 1, status: '等待中' }, { id: 2, status: '执行中' }, { id: 3, status: '成功' }, { id: 4, status: '失败' }],
        TaskModuleList: [],
        taskTypeList: [],
        zykArrList: []
      },

      taskType: null,
      showErrorInfo: false
    };
  },


  created() {
    this.getTaskModule()                   // 获取任务模块
    this.search()

    this.drowDown.zykArrList = JSON.parse(sessionStorage.getItem('zykArr'))
    this.drowDown.zykArrList = this.drowDown.zykArrList.map(item => {
      let i = item.zykName.indexOf(' ') + 1
      let zykName = item.zykName.slice(i, item.zykName.length)
      return {
        zykName,
      }
    })



  },



  methods: {
    // 获取任务模块
    getTaskModule() {
      this.$axios.post(this.$apiurls.dataStatisticsMonitor_getLrmv2StatisticalTaskModuleInfoList, {
        loading: false
      }).then((res) => {
        this.drowDown.TaskModuleList = res.data.map(item => {
          let name = item.name
          let value = item.value
          return {
            name,
            value
          }
        })
      })
    },

    // 切换任务模块
    changeTask(item) {
      this.getaskListHandler(item)
    },

    // 获取任务类型集合
    getaskListHandler(item) {
      this.$axios.post(this.$apiurls.dataStatisticsMonitor_getLrmv2StatisticalTaskInfoList, item, {
        loading: false,
      }).then((res) => {
        this.drowDpwn.taskTypeList = res.data
      });
    },

    // 任务数据执行统计状态总进度列表
    search() {
      this.$axios.post(this.$apiurls.dataStatisticsMonitor_getLrmv2StatisticalTaskModuleInfoVoList, this.searchData.id, {
        loading: false,
      }).then((res) => {
        this.tableData.OneTable = res.data
      })
    },
    // 进入二级菜单
    see(row) {
      this.taskType = row
      this.oneShow = false
      this.searchTwoTable()
    },
    // 二级查询
    searchTwoTable() {
      this.searchDataTow.taskType = this.taskType
      this.$axios.post(this.$apiurls.dataStatisticsMonitor_getLrmv2StatisticalTaskZykInfoByTypeOrStatus, this.searchDataTow, {
        loading: false,
      }).then((res) => {
        this.dataHandler(res.data.list)

        for (let i = 0; i < res.data.list.length; i++) {
          if (res.data.list[i].failInfo) {
            this.content = res.data.list[i].failInfo
            res.data.list[i].failInfo = res.data.list[i].failInfo.slice(0, 8) + '....'
          }
        }

        this.tableData.towTable.total = res.data.total


      })
    },


    // 处理数据
    dataHandler(data) {
      data.forEach(item => {
        switch (item.taskStatus) {
          case 1:
            item.taskStatus = '等待中';
            break;
          case 2:
            item.taskStatus = '执行中';
            break;
          case 3:
            item.taskStatus = '成功';
            break;
          case 4:
            item.taskStatus = '失败';
          default:
        }

        switch (item.taskId) {
          case 1:
            item.taskId = '每周画像更新';
            break;
          case 2:
            item.taskId = '课程质量报告';
            break;
          case 3:
            item.taskId = '无活动数据';
            break;
          case 4:
            item.taskId = '基本报告';
          case 5:
            item.taskId = '简报';
          case 6:
            item.taskId = '月度报告';
          case 7:
            item.taskId = '季度报告';
          case 8:
            item.taskId = '年度报告';
          case 9:
            item.taskId = '国家整体应用分析报告'
          default:
        }
      })

      this.tableData.towTable.list = data
      this.tableData.towTable.list.forEach(item => {
        if (item.taskStatus == '失败') {
          this.showErrorInfo = true
        } else {
          this.showErrorInfo = false
        }
      })

      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].consumingTime = (this.tableData[i].consumingTime / 60000).toFixed(2)
      }
    },


    // 切换页脚
    changeHandler(pageNum) {
      this.searchDataTow.pageDto.pageNum = pageNum
      this.$axios.post(this.$apiurls.dataStatisticsMonitor_getLrmv2StatisticalTaskZykInfoByTypeOrStatus, this.searchDataTow, {
        loading: false,
      }).then((res) => {
        this.dataHandler(res.data.list)
        this.total = res.data.total
      });
    },

    backOneTable() {
      this.oneShow = true
    }
  },
};
</script>

<style  lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style  lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" scoped>
.el-form {
  height: 100%;
}
.table_box {
  width: 100%;
}

// 行间距
.pop_up ::v-deep .el-table__body {
  border-spacing: 0px 0px;
}

.pop_up ::v-deep .el-table thead.is-group th.el-table__cell {
  background: rgba(31, 50, 94, 0.8);
  border-bottom: 1px solid #39456e !important;
  border-right: 1px solid #39456e !important;
}

.pop_up ::v-deep .el-table tr {
  background: rgba(35, 42, 67, 1);
}

.pop_up ::v-deep .el-table--enable-row-hover .el-table__body tr td,
.pop_up ::v-deep .el-table th {
  border-bottom: 1px solid #39456e !important;
  color: #fff;
  border-right: 1px solid #39456e !important;
}

.pop_up ::v-deep .el-table--border,
.pop_up ::v-deep .el-table--group {
  border-width: 0px;
}

.pop_up ::v-deep .el-table--border::after,
.pop_up ::v-deep .el-table--group::after {
  width: 0px !important;
}

.el-icon-top,
.el-icon-bottom {
  font-size: 20px;
  font-weight: 700;
  color: #1bf6f8;
}
.el_tooltip_popper {
  width: 200px;
  height: 180px;
  overflow: hidden;
  overflow-y: auto;
}
.success {
  color: #89ff00;
}
.error {
  color: red;
}
.implement {
  color: yellow;
}
</style>

<style>
.el-select-dropdown {
  position: absolute;
  z-index: 1001;
  border: none !important;
  max-height: 268px;
  border-radius: 4px;
  background-color: transparent;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  margin: 5px 0;
}
.el-popper .popper__arrow,
.el-popper .popper__arrow::after {
  position: absolute;
  display: "";
  width: "";
  height: "";
  border: none;
  border-style: "";
}
.el-select-dropdown__list {
  box-sizing: border-box;
  padding: -1px 0;
  background: rgba(26, 38, 72) !important;
}
.el-select-dropdown__item {
  color: #fff !important;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  /* width: 434.25px; */
  background: transparent;
  border: 1px solid rgba(27, 246, 248);
}

.el-select-dropdown__item.selected {
  color: rgba(27, 246, 248);
}

.back {
  position: absolute;
  right: -630px;
  background: rgba(46, 62, 99, 0.79);
  border: none;
}

.back:hover {
  background: rgba(46, 62, 99, 0.79) !important;
}
</style>

